<!-- login_system_bkg_cover -->
<div class="container full_page_container centered_flex_container">
  <!-- <div class="cs_page_cover bkg_img">
    <p class="title">Coming Soon...</p>
    <p class="punch_line">Amazingness is under progress.</p>
    <p class="punch_line">Stay Tuned!</p>
    <button class="danger_button" (click)="logout()">Logout</button>
  </div> -->
</div>
